import { AxiosResponse } from "axios";
import axiosClient from "../../common/axios/axiosConfig";
import { IMessage } from "../../common/interfaces/IMessage";
import useQuery from "../../utils/useQuery";

interface IParams {
  lastId: string|null;
}

export const getMessages = async (
  params: IParams
): Promise<AxiosResponse<IMessage[]>> => {
  const token = useQuery().get("token");
  return axiosClient.get(`/chat/messages`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
